import gql from 'graphql-tag';

export const CREATE_USER_MUTATION = gql`
  mutation createUser(
    $firstName: String!
    $lastName: String!
    $email: String!
    $password: String!
    $validationCode: String!
  ) {
    createUser(
      firstName: $firstName
      lastName: $lastName
      email: $email
      password: $password
      validationCode: $validationCode
    ) {
      id
      firstName
      lastName
      email
    }
  }
`;

export const CHANGE_USER_MUTATION = gql`
  mutation changeUser($firstName: String!, $lastName: String!) {
    changeUser(firstName: $firstName, lastName: $lastName) {
      id
      firstName
      lastName
      email
    }
  }
`;

export const LOGIN_MUTATION = gql`
  mutation login($email: String!, $password: String!, $token: String) {
    login(email: $email, password: $password, oneTimeToken: $token) {
      status
      accessToken
      accessTokenExpirySeconds
    }
  }
`;

export const CHANGE_EMAIL_USER_REQUEST_MUTATION = gql`
  mutation changeEmailUserRequest($email: String!) {
    changeEmailUserRequest(newEmail: $email)
  }
`;

export const CHANGE_EMAIL_USER_MUTATION = gql`
  mutation changeEmailUser($email: String!, $token: String!) {
    changeEmailUser(newEmail: $email, oneTimeToken: $token) {
      id
      firstName
      lastName
      email
    }
  }
`;

export const RESET_PASSWORD_REQUEST_MUTATION = gql`
  mutation resetPasswordRequest($email: String!) {
    resetPasswordRequest(email: $email)
  }
`;

export const RESET_PASSWORD_MUTATION = gql`
  mutation resetPassword($email: String!, $token: String) {
    resetPassword(email: $email, oneTimeToken: $token)
  }
`;

export const CHANGE_PASSWORD_MUTATION = gql`
  mutation changePassword(
    $email: String!
    $password: String!
    $newPassword: String!
  ) {
    changePassword(
      email: $email
      password: $password
      newPassword: $newPassword
    )
  }
`;

export const UPDATE_TOKEN_MUTATION = gql`
  mutation updateToken {
    updateToken {
      status
      accessToken
      accessTokenExpirySeconds
    }
  }
`;

export const LOGOUT_MUTATION = gql`
  mutation logout {
    logout
  }
`;

export const USER_QUERY_GET_COUNT = gql`
  query getUserCount($onlyConfirmed: Boolean, $createdLastNumberOfDays: Int) {
    getUserCount(
      onlyConfirmed: $onlyConfirmed
      createdLastNumberOfDays: $createdLastNumberOfDays
    )
  }
`;

export const UPDATE_USER_ACCESS_CONTROL = gql`
  mutation updateUserAccessControl(
    $userId: ID!
    $role: String!
    $resource: String!
  ) {
    updateUserAccessControl(userId: $userId, role: $role, resource: $resource) {
      result
      details
    }
  }
`;

export const GET_USERS = gql`
  query getUsers(
    $search: String
    $roleFilter: [String!]
    $limit: Int
    $offset: Int
  ) {
    getUsers(
      search: $search
      roleFilter: $roleFilter
      limit: $limit
      offset: $offset
    ) {
      id
      firstName
      lastName
      email
      country
      accessControl {
        role
        resource
      }
    }
  }
`;
